var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:progress-star-four-points"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 4V2C17.66 2.5 21.33 6.19 21.85 10.85C22.45 16.34 18.5 21.28 13 21.88V19.88C16.64 19.43 19.5 16.56 19.96 12.92C20.0895 11.8772 20.0122 10.819 19.7324 9.80614C19.4526 8.79323 18.9759 7.84542 18.3294 7.01694C17.683 6.18846 16.8796 5.49556 15.9651 4.97788C15.0506 4.46021 14.043 4.12791 13 4ZM5.67 4.2C7.18575 2.94859 9.04287 2.18205 11 2V4.06C9.57 4.26 8.22 4.84 7.1 5.74L5.67 4.2ZM2.05 11C2.2357 9.04196 3.00568 7.18495 4.26 5.67L5.69 7.1C4.80399 8.2297 4.2376 9.5766 4.05 11H2.05ZM4.27 18.33C3.02768 16.8078 2.25928 14.9546 2.06 13H4.06C4.24 14.42 4.81 15.77 5.69 16.9L4.27 18.33ZM5.67 19.74L7.06 18.37H7.1C8.23 19.25 9.58 19.82 11 20V22C9.04 21.79 7.18 21 5.67 19.74ZM12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17Z",
    fill: "#B88D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcampaign);
export default __webpack_public_path__ + "static/media/gcampaign.758ef8747bd78286ab12e92b7b9dd41e.svg";
export { ForwardRef as ReactComponent };